export default {
    TAMANHO_PAGINA: 20
};
